import { useMutation } from '@apollo/client';
import useNotifier from 'hooks/useNotifier';
import { handleGQLErrors } from 'utils/gqlErrors';
import clientAccount from '../../utils/clientAccount';
import { creditCreditAccountMutation } from '../mutations';
import {
  CreditCreditAccount,
  CreditCreditAccountVariables,
} from '../types/CreditCreditAccount';

const useCreditAccount = ({ onComplete }: { onComplete?: (balance: number) => void }) => {
  const notify = useNotifier();
  const [mutation, mutationOpts] = useMutation<
    CreditCreditAccount,
    CreditCreditAccountVariables
  >(creditCreditAccountMutation, {
    client: clientAccount,
    onCompleted: (data) => {
      if (onComplete) {
        onComplete(data?.creditCreditAccount?.credit?.balance || 0);
      } else {
        notify({ text: 'Accounted credited successfully', status: 'success' });
      }
    },
    onError: (err) => {
      handleGQLErrors(notify, err);
    },
  });

  return {
    mutation,
    mutationOpts,
  };
};

export default useCreditAccount;
